import { AdminQueueTaskSummary } from "sockapi/scope-specs/admin-queue-spec";
import { PuzzleMetadata } from "sockapi/puzzle-data";

export enum HuntNotificationType {
  INTERNAL = "internal",
  ADMIN_QUEUE_TASK = "admin_queue_task",
  SUBMISSION_REJECTED = "submission_rejected",
  HINT_ANSWERED = "hint_answered",
  UNLOCK = "unlock",
  SOLVE = "solve",
  ERRATUM = "erratum",
  VICTORY = "victory",
}

export type HuntNotification =
  | {
      type: HuntNotificationType.INTERNAL;
      message: string;
    }
  | {
      type: HuntNotificationType.ADMIN_QUEUE_TASK;
      taskId: string;
      taskSummary: AdminQueueTaskSummary;
    }
  | {
      type: HuntNotificationType.ERRATUM | HuntNotificationType.VICTORY;
    }
  | {
      type:
        | HuntNotificationType.SUBMISSION_REJECTED
        | HuntNotificationType.HINT_ANSWERED
        | HuntNotificationType.SOLVE;
      puzName: string;
    }
  | {
      type: HuntNotificationType.UNLOCK;
      puzData: PuzzleMetadata;
    };
